import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CheckoutProfileEdit" })
export default class CheckoutProfileEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isEditAddress: boolean = false;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public editData: any = null;
    public formData: any = { profileTaxType: null, country: null, zone: null };
    public countries: any[] = [];
    public provinces: any[] = [];
    public profileTaxTypes: any[] = [];
    public shippingModes: any[] = [];
    public shippingAddresses: any[] = [];
    public validationErrors: any[] = [];
    public shippingAddress: any = {};

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    get cart() {
        return this.$store.getters["cartStore/cart"]
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.StoreCheckout_GetProfileEditData)).data;

        this.formData.name = this.editData.userProfile.name;
        this.formData.surname = this.editData.userProfile.surname;
        this.formData.profileTaxType = this.editData.userProfile.profileTaxType === "" ? null : this.editData.userProfile.profileTaxType;
        this.formData.country = this.editData.userProfile.country === "" ? null : this.editData.userProfile.country;
        this.formData.zone = this.editData.userProfile.zone;
        this.formData.postCode = this.editData.userProfile.postCode;
        this.formData.address = this.editData.userProfile.address;
        this.formData.location = this.editData.userProfile.location;
        this.formData.taxCode = this.editData.userProfile.taxCode;
        this.formData.company = this.editData.userProfile.company;
        this.formData.vatCode = this.editData.userProfile.vatCode;
        this.formData.certifiedEmail = this.editData.userProfile.certifiedEmail;
        this.formData.sdiCode = this.editData.userProfile.sdiCode;
        this.formData.phone = this.editData.userProfile.phone;

        this.profileTaxTypes = this.editData.profileTaxTypes;
        this.countries = this.editData.countries;
        this.provinces = this.editData.provinces;
        this.shippingModes = this.editData.shippingModes;
        this.shippingAddresses = this.editData.shippingAddresses;

        this.formData.shippingMode = this.shippingAddresses.length == 0 ? "ProfileAddress" : null;
    }

    public setProfileTaxType() {
        if (this.formData.profileTaxType === "Company") {
            this.formData.taxCode = null;
        }

        if (this.formData.profileTaxType === "Person") {
            this.formData.company = null;
            this.formData.vatCode = null;
            this.formData.certifiedEmail = null;
            this.formData.sdiCode = null;
            this.formData.workingRole = null;
        }
    }

    public setCountryType() {
        this.formData.zone = null;
    }

    public setShippingMode() {
        if (this.formData.shippingMode === "ProfileAddress") {
            this.isEditAddress = false;
        } else {
            this.isEditAddress = true;
        }
    }

    public async controlEdit(value: any) {
        this.shippingAddresses = (await Axios.post(this.routes.AccountShippingAddress_GetShippingAddresses)).data;
        this.isEditAddress = value;
        this.formData.shippingMode = null;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.shippingMode !== "ProfileAddress" ? this.shippingAddress = {} : null;

        try {
            if (this.formData.shippingMode === "ProfileAddress") {
                this.shippingAddress.name = this.formData.name;
                this.shippingAddress.surname = this.formData.surname;
                this.shippingAddress.address = this.formData.address;
                this.shippingAddress.postCode = this.formData.postCode;
                this.shippingAddress.location = this.formData.location;
                this.shippingAddress.zone = this.formData.zone;
                this.shippingAddress.country = this.formData.country;
                this.shippingAddress.phone = this.formData.phone;
                this.shippingAddress.isDefault = true;

                await Axios.post(this.routes.AccountShippingAddress_SaveShippingAddress, this.shippingAddress);
            }

            await Axios.post(this.routes.StoreCheckout_ProfileEdit, this.formData);

            this.isSuccess = true;

            window.location.href = this.returnUrl ? this.returnUrl : "/";
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};